import React, { useState } from "react";
import { Select, InputNumber } from "antd";
import { isEmpty, get } from "lodash";

const Criteria = (props: any) => {
  const _x = props.selectedValue;
  const [criteriaSelected, setCriteriaSelected] = useState(_x[0].filterType);

  const _xFilterValue = get(_x[0], "filterValues", []);

  return (
    <div className="drawerFiltersWrapper__criteria">
      <Select
        style={{ width: 300 }}
        placeholder={"Select"}
        onChange={(value) => {
          setCriteriaSelected(value);
          if (value === "Deselect") {
            props.changeHandler(props.idx, []);
          } else {
            _x[0].filterType = value;
            props.changeHandler(props.idx, _x);
          }
        }}
        value={criteriaSelected}
        className="drawerFiltersWrapper__criteria__select"
      >
        <Select.Option value="Deselect">Deselect</Select.Option>
        <Select.Option value="Greater Than">Greater Than</Select.Option>
        <Select.Option value="Greater & Equal">Greater & Equal</Select.Option>
        <Select.Option value="Less Than">Less Than</Select.Option>
        <Select.Option value="Lesser & Equal">Lesser & Equal</Select.Option>
        <Select.Option value="Between">Between</Select.Option>
        <Select.Option value="Not Between">Not Between</Select.Option>
      </Select>
      {!isEmpty(criteriaSelected) && criteriaSelected !== "Deselect" ? (
        criteriaSelected === "Between" || criteriaSelected === "Not Between" ? (
          <div className="drawerFiltersWrapper__criteria__range">
            <InputNumber
              placeholder="0.00"
              value={_x?.[0]?.filterValues?.[0]}
              onChange={(value) => {
                _xFilterValue[0] = value;
                _x[0].filterValues = _xFilterValue;
                props.changeHandler(props.idx, _x);
              }}
            />{" "}
            -{" "}
            <InputNumber
              placeholder="0.00"
              value={_x?.[0]?.filterValues?.[1]}
              onChange={(value) => {
                _xFilterValue[1] = value;
                _x[0].filterValues = _xFilterValue;
                props.changeHandler(props.idx, _x);
              }}
            />
          </div>
        ) : (
          <InputNumber
            placeholder="0.00"
            className="drawerFiltersWrapper__criteria__input"
            value={_x[0]?.filterValues?.[0]}
            onChange={(value) => {
              _x[0].filterValues = [value];
              props.changeHandler(props.idx, _x);
            }}
          />
        )
      ) : null}
    </div>
  );
};

export default Criteria;
